import { Component } from '@angular/core';
import { IMenuInterface } from '../../../../model/commonModel';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import {
  StorageKey,
  StorageService,
} from '../../../../services/common/storage.service';
import { AuthenticationService } from '../../../../services/common/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from '../../../../services/api-url-helper/api-url-helper';
import { ApiService } from '../../../../services/api.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin-side-nav',
  templateUrl: './admin-side-nav.component.html',
  styleUrl: './admin-side-nav.component.scss',
})
export class AdminSideNavComponent {
  menus: IMenuInterface[] = [];
  activeMenu: any = null;
  openMenus: Set<any> = new Set();
  private routeSubscription!: Subscription;
  UserType: any;
  isLoggedIn = false;

  constructor(
    private router: Router,
    private storageService: StorageService,
    private authservice: AuthenticationService,
    private toastr: ToastrService,
    private service: ApiService,
    private url: ApiUrlHelper,
    private translate: TranslateService
  ) {
    // this.initMenu();
    // this.menus.sort(function (a, b) {
    //   return a.title.localeCompare(b.title);
    // });
    // this.menus.forEach((element) => {
    //   element.subMenu?.sort(function (a, b) {
    //     return a.title.localeCompare(b.title);
    //   });
    // });
    // this.menus.unshift({
    //   title: 'Dashboard',
    //   link: '/admin/dashboard',
    //   icon: 'ri-dashboard-fill',
    // });
  }

  ngOnInit() {
    this.routeSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateActiveState(event.urlAfterRedirects);
      }
    });
    this.updateActiveState(this.router.url);

    const token = this.storageService.getValue(StorageKey.authToken);
    if (token) {
      this.isLoggedIn = true;
      this.UserType = this.storageService.getTokenData().UserTypeId;
      this.getMenuPermissionManagementList();
      this.getMenuManagementList();
    }
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  getMenuManagementList(): void {
    try {
      const tokenData = this.storageService.getTokenData();
      if (!tokenData?.RoleId) {
        return;
      }
      const apiUrl = `${this.url.apiUrl.AccessManagement.getAccessMenuListView}/${tokenData?.RoleId}`;
      this.service.doGet(apiUrl).subscribe({
        next: (data) => {
          if (data.Success && data.Data) {
            const MenuList = data.Data;
           
            if (MenuList && MenuList.length > 0) {
              this.menus = this.transformApiData(MenuList);
              // console.log( this.menus)
              // this.storageService.setValue(
              //   StorageKey.menuList,
              //   JSON.stringify(this.menus)
              // );
              setTimeout(() => {
                let body = document.getElementsByTagName('body')[0];
                let script = document.createElement('script');
                script.type = 'text/javascript';
                script.id = 'sidebar-script';
                script.src = 'assets/pro-sidebar-template/main.js';
                body.appendChild(script);
              }, 100);
            } else {
              this.toastr.error(data.Message ||this.translate.instant('NO_MENU_DATA'));
            }
          } else {
            //this.toastr.error(data.Message || this.translate.instant('FAILED_TO_FETTCH_MENU_LIST'));
          }
        },
        error: () => {
          this.toastr.error(
            this.translate.instant('FETCH_ROLE_PERMISSION')
          );
        },
      });
    } catch (err) {
      console.error('Error in getMenuManagementList:', err);
    }
  }

  private transformApiData(apiData: any[]): IMenuInterface[] {
    return apiData.map((item) => {
      const menuItem: IMenuInterface = {
        title: item.Title,
        link: item.Url || '',
        icon: item.Icon || 'ri-book-2-fill',
        CanView: item.CanView,
        CanEdit: item.CanEdit,
        CanDelete: item.CanDelete,
        subMenu:
          item.AllItems && item.AllItems.length > 0
            ? item.AllItems.map((subItem) => ({
                title: subItem.Title,
                link: subItem.url || '',
                CanView: item.CanView,
                CanEdit: item.CanEdit,
                CanDelete: item.CanDelete,
              }))
            : undefined,
      };
      return menuItem;
    });
  }

  toggleMenu(menu: any) {
    if (this.openMenus.has(menu)) {
      this.openMenus.delete(menu);
    } else {
      this.openMenus.add(menu);
    }
  }

  updateActiveState(currentUrl: string) {
    this.activeMenu = null;
    this.openMenus.clear();

    for (let menu of this.menus) {
      if (menu.link && currentUrl.includes(menu.link)) {
        this.activeMenu = menu;
        return;
      }
      if (menu.subMenu?.length) {
        for (let sub of menu.subMenu) {
          if (sub.link === currentUrl) {
            this.activeMenu = sub;
            this.openMenus.add(menu);
            return;
          }
        }
      }
    }
  }

  isActive(menu: any): boolean {
    if (menu.link && this.activeMenu === menu) return true;
    if (menu.subMenu?.length) {
      return menu.subMenu.some((sub: any) => this.activeMenu === sub);
    }
    return false;
  }

  // initMenu() {
  //   this.menus = [
  //     {
  //       title: 'Master Modules',
  //       link: '',
  //       icon: 'ri-book-2-fill',
  //       subMenu: [
  //         {
  //           title: 'Education Master',
  //           link: '/admin/education-list',
  //         },
  //         {
  //           title: 'Suffix Master',
  //           link: '/admin/suffix',
  //         },
  //         {
  //           title: 'Resident Type',
  //           link: '/admin/residenttype',
  //         },
  //         {
  //           title: 'House Type Master',
  //           link: '/admin/house-type',
  //         },
  //         {
  //           title: 'Language Master',
  //           link: '/admin/language',
  //         },
  //         {
  //           title: 'Vehicle Primary Use Master',
  //           link: '/admin/vehicle-primary',
  //         },
  //         {
  //           title: 'Prefix Master',
  //           link: '/admin/prefix-list',
  //         },
  //         {
  //           title: 'Insurance Carriers Master',
  //           link: '/admin/insurance-carriers',
  //         },
  //         {
  //           title: 'Car Registration Type Master',
  //           link: '/admin/car-registration-types',
  //         },
  //         {
  //           title: 'Credit Score Type Master',
  //           link: '/admin/credit-score-types',
  //         },
  //         {
  //           title: 'Relationship Master',
  //           link: '/admin/relationship',
  //         },
  //         {
  //           title: 'Employeement Status',
  //           link: '/admin/employeement-status',
  //         },
  //         {
  //           title: 'Coverage Master',
  //           link: '/admin/coverage',
  //         },
  //         {
  //           title: 'State Wise Coverage',
  //           link: '/admin/state-wise-coverage',
  //         },
  //         {
  //           title: 'Dispute Master',
  //           link: '/admin/dispute-list',
  //         },
  //         {
  //           title: 'Coverage Category Master',
  //           link: '/admin/coverage-category',
  //         },
  //         {
  //           title: 'Marital Status Master',
  //           link: '/admin/marital-status',
  //         },
  //         {
  //           title: 'Incident Type Master',
  //           link: '/admin/incident-types',
  //         },
  //         {
  //           title: 'Violation Tickets Master',
  //           link: '/admin/violation-tickets',
  //         },
  //         {
  //           title: 'Car Make Master',
  //           link: '/admin/car-make',
  //         },
  //         {
  //           title: 'Vehicle Type',
  //           link: '/admin/vehicle-type',
  //         },
  //         {
  //           title: 'Product Availability',
  //           link: '/admin/product-availability',
  //         },
  //         {
  //           title: 'Demo Appointment Master',
  //           link: '/admin/demo-appointment',
  //         },
  //         {
  //           title: 'Coverage Value Range Master',
  //           link: '/admin/coverage-value-range-master',
  //         },
  //         {
  //           title: 'Lead Master',
  //           link: '/admin/lead-master/list',
  //         },
  //         {
  //           title: 'Lead Purchase Master',
  //           link: '/admin/lead-purchase-master',
  //         },
  //         {
  //           title: 'Number of Agents to Receive lead',
  //           link: '/admin/numberOfAgents-receive-lead',
  //         },
  //         {
  //           title: 'Wallet Credit Configuration',
  //           link: '/admin/walled-credit-configuration',
  //         },
  //         {
  //           title: 'License Type Master',
  //           link: '/admin/license-type',
  //         },
  //         {
  //           title: 'Referral Amount Management',
  //           link: '/admin/manage-referral-amount',
  //         },
  //       ],
  //     },
  //     // {
  //     //   title: 'Coverage Management',
  //     //   link: '',
  //     //   icon: 'ri-book-2-fill',
  //     //   subMenu: [
  //     //     {
  //     //       title: 'Bodily Injury',
  //     //       link: '/admin/coverage-management/bodily-injury',
  //     //     },
  //     //     {
  //     //       title: 'Property Damage',
  //     //       link: '/admin/coverage-management/property-damage',
  //     //     },
  //     //     {
  //     //       title: 'Uninsured/Underinsured Motorist',
  //     //       link: '/admin/coverage-management/uninsured-Underinsured-Motorist',
  //     //     },
  //     //     {
  //     //       title: 'Medical Payments',
  //     //       link: '/admin/coverage-management/medical-payments',
  //     //     },
  //     //     {
  //     //       title: 'Personal Injury Protection',
  //     //       link: '/admin/coverage-management/personal-injury-protection',
  //     //     },
  //     //     {
  //     //       title: 'Optional Basic Economic Loss',
  //     //       link: '/admin/coverage-management/optional-basic-economic-loss',
  //     //     },
  //     //     {
  //     //       title: 'Additional Personal Injury Protection',
  //     //       link: '/admin/coverage-management/additional-personal-injury-protection',
  //     //     },
  //     //     {
  //     //       title: 'Comprehensive With Full Glass Deductible',
  //     //       link: '/admin/coverage-management/comprehensive-full-glass-deductible',
  //     //     },
  //     //     {
  //     //       title: 'Rental Car Reimbursement',
  //     //       link: '/admin/coverage-management/rental-car-reimbursement',
  //     //     },
  //     //     {
  //     //       title: 'Collision Deductible',
  //     //       link: '/admin/coverage-management/collision-deductible',
  //     //     },
  //     //     {
  //     //       title: 'Towing & Roadside Assistance',
  //     //       link: '/admin/coverage-management/towing-roadside-assistance',
  //     //     },
  //     //   ],
  //     // },
  //     {
  //       title: 'CMS Management',
  //       link: '',
  //       icon: 'ri-book-2-fill',
  //       subMenu: [
  //         {
  //           title: 'About Us',
  //           link: '/admin/cms-management/about-us',
  //         },
  //         {
  //           title: 'Contact Us',
  //           link: '/admin/cms-management/contact-us',
  //         },
  //         {
  //           title: 'Terms and Conditions',
  //           link: '/admin/cms-management/terms-and-conditions',
  //         },
  //         {
  //           title: 'Privacy Policy',
  //           link: '/admin/cms-management/privacy-policy',
  //         },
  //         {
  //           title: `FAQ's`,
  //           link: '/admin/cms-management/faqs',
  //         },
  //         // {
  //         //   title: 'How It Works',
  //         //   link: '/admin/cms-management/how-it-works',
  //         // },
  //         {
  //           title: 'Banner Management',
  //           link: '/admin/cms-management/banner-management',
  //         },
  //       ],
  //     },

  //     {
  //       title: 'Customer Referrals',
  //       link: '/admin/Customer-Referrals',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Demo Book Appointment',
  //       link: '/admin/demo-book-appointment',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Firm Management',
  //       link: '/admin/firm-management',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Number of Customer Disputes Againist Agents (Admin)',
  //       link: '/admin/customer-dispute-for-admin',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Firm With Expired Licenses',
  //       link: '/admin/firm-with-expired-licenses',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Reports',
  //       link: '',
  //       icon: 'ri-bar-chart-2-fill',
  //     },
  //     {
  //       title: 'Agent Management',
  //       link: '/admin/agent',
  //       icon: 'ri-bar-chart-2-fill',
  //     },
  //     {
  //       title: 'Transaction Management',
  //       link: '/admin/transaction-management',
  //       icon: 'ri-bar-chart-2-fill',
  //     },
  //     {
  //       title: 'Refer a Friend',
  //       link: '/admin/cms-management/how-it-works',
  //       icon: 'ri-bar-chart-2-fill',
  //     },
  //     {
  //       title: 'Subscription Plan Master',
  //       link: '/admin/subscription-plan',
  //       icon: 'ri-bar-chart-2-fill',
  //     },
  //     {
  //       title: 'Reports Management',
  //       link: '',
  //       icon: 'ri-book-2-fill',
  //       subMenu: [
  //         {
  //           title: 'Customer',
  //           link: '/admin/report-management/customer',
  //         },
  //         {
  //           title: 'Firm',
  //           link: '/admin/report-management/firms',
  //         },
  //         {
  //           title: 'Agent',
  //           link: '/admin/report-management/agents',
  //         },
  //       ],
  //     },
  //     {
  //       title: 'Lead Not Yet Matched',
  //       link: '/admin/lead-not-matched',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Firm With Incomplete Information',
  //       link: '/admin/firm-with-incomplete-information',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Customer Management',
  //       link: '/admin/customer-management/list',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'Reported Review Management',
  //       link: '/admin/report-review-master',
  //       icon: 'ri-book-2-fill',
  //     },
  //     {
  //       title: 'User Management',
  //       link: '',
  //       icon: 'ri-book-2-fill',
  //       subMenu: [
  //         {
  //           title: 'Role Management',
  //           link: '/admin/user-management/role',
  //         },
  //         {
  //           title: 'User Managment',
  //           link: '/admin/user-management/user',
  //         },
  //         {
  //           title: 'Access Management',
  //           link: '/admin/user-management/access',
  //         },
  //       ],
  //     },
  //     {
  //       title: 'Coming Soon',
  //       link: '/admin/manage-coming-soon',
  //       icon: 'ri-book-2-fill',
  //     },
  //   ];

  //   this.menus.sort((a, b) => a.title.localeCompare(b.title));

  //   // Sort the submenus within each menu
  //   this.menus.forEach((menu) => {
  //     if (menu.subMenu) {
  //       menu.subMenu.sort((a, b) => a.title.localeCompare(b.title));
  //     }
  //   });
  // }

  refreshPage() {
    window.location.reload();
  }

  navigateToDashboard() {
    if (!this.isLoggedIn) {
      this.router.navigate(['/login']);
      return;
    }
    switch (this.UserType) {
      case 1: // Admin
        this.router.navigate(['/admin/dashboard']);
        break;
      case 2: // Customer
        this.router.navigate(['/homepage']);
        break;
      case 3: // Firm
        this.router.navigate(['/dashboard']);
        break;
      case 4: // Agent
        this.router.navigate(['/agent-dashboard']);
        break;
      default:
        this.router.navigate(['/']);
        break;
    }
  }

  getMenuPermissionManagementList(): void {
    try {
      const tokenData = this.storageService.getTokenData();
      if (!tokenData?.RoleId) {
        return;
      }
      const apiUrl = `${this.url.apiUrl.AccessManagement.getAccessMenuList}/${tokenData?.RoleId}`;
      this.service.doGet(apiUrl).subscribe({
        next: (data) => {
          if (data.Success && data.Data) {
            const MenuList = data.Data;
              this.storageService.setValue(
                StorageKey.menuList,
                JSON.stringify(MenuList)
              );
              // setTimeout(() => {
              //   let body = document.getElementsByTagName('body')[0];
              //   let script = document.createElement('script');
              //   script.type = 'text/javascript';
              //   script.id = 'sidebar-script';
              //   script.src = 'assets/pro-sidebar-template/main.js';
              //   body.appendChild(script);
              // }, 100);
          } else {
            this.toastr.error(data.Message || this.translate.instant('FAILED_TO_FETTCH_MENU_LIST'));
          }
        },
        error: () => {
          this.toastr.error(
            this.translate.instant('FETCH_ROLE_PERMISSION')
          );
        },
      });
    } catch (err) {
      console.error('Error in getMenuManagementList:', err);
    }
  }
}
